import { CompleteImpactAttributes } from '@loyalty/shared-common/event-processing-api-client';
import {
  CurrencyAttributes,
  LevelAttributes,
  LevelsConfigAttributes,
  ReferralConfigAttributes,
} from '@loyalty/shared-common/gamification-api-client';
import { Leaderboard } from '@loyalty/shared-common/leaderboard-api-client';
import {
  MembershipAttributes,
  ProfileAttributes,
  TransactionAttributes,
} from '@loyalty/shared-common/profile-api-client';
import { getLocalizedProperty, uuid } from '@loyalty/shared-common';
import {
  CurrenciesFixture,
  LevelsFixture,
  buildLeaderboardFixture,
  buildLevelConfigFixture,
  buildMembershipFixture,
  buildProfileFixture,
  buildTransactionsFixture,
  makeRewardsFixture,
  programIdFixture,
} from './fixtures';
import type { PortalInteractionRow } from './components/interactions-list-component/InteractionsListComponent';

export interface WidgetState {
  profile: ProfileAttributes;
  isInternalUser: boolean;
  membership: MembershipAttributes;
  currencies: CurrencyAttributes[];
  leaderboardData: { [currencyId: string]: Leaderboard };
  programId: string;
  templateId: string;
  levels: LevelAttributes[];
  programUrl: string;
  levelConfig?: LevelsConfigAttributes;
  transactionsFixture?: TransactionAttributes[];
  interactionsFixture?: PortalInteractionRow[];
  rewardsRules?: CompleteImpactAttributes;
  referralConfig?: ReferralConfigAttributes;
  children?: any;
}

export function buildWidgetStateFixture(
  currencies: CurrencyAttributes[],
  referralConfig: ReferralConfigAttributes | undefined,
  programUrl: string,
  languages: string[],
): WidgetState {
  return {
    profile: buildProfileFixture(currencies),
    isInternalUser: true,
    membership: buildMembershipFixture(programIdFixture),
    levels: LevelsFixture,
    transactionsFixture: buildTransactionsFixture(currencies),
    interactionsFixture: [
      {
        id: uuid(),
        eventTimestamp: '2025-03-25T00:00:00.000Z',
        label: 'Ticket receipt',
        status: 'Pending',
      },
      {
        id: uuid(),
        eventTimestamp: '2025-03-18T00:00:00.000Z',
        label: 'Ticket receipt',
        status: 'Accepted',
      },
      {
        id: uuid(),
        eventTimestamp: '2025-03-11T00:00:00.000Z',
        label: 'Ticket receipt',
        status: 'Refused',
      },
    ],
    currencies,
    programId: programIdFixture,
    templateId: uuid(),
    referralConfig: {
      ...referralConfig!,
      i18nAttributes: Object.fromEntries(
        languages?.map(lng => [lng, { link: getLocalizedProperty(referralConfig, 'link', lng) }]),
      ),
    },
    programUrl: programUrl,
    levelConfig: buildLevelConfigFixture({ withExpiration: true }),
    leaderboardData: buildLeaderboardFixture(currencies),
    rewardsRules: makeRewardsFixture(currencies),
  };
}

export const widgetStateFixture = buildWidgetStateFixture(
  CurrenciesFixture,
  {
    id: uuid(),
    i18nAttributes: {
      en: { link: 'https://loyalty.ecommerce.test?referralCode={referralCode}' },
    },
  },
  'https://player.loyalty.qualifio.localhost',
  ['en', 'fr'],
);
